import React from "react";
import { Link } from "gatsby"
import marked from 'marked';

import CDNImage from '../../common/cdn-image';
import StartingPrintPrice from '../../shop/controls/starting-print-price';

import '../../../styles/shop/product-list.scss';

const ProductList = ({
	page,
	perPage,
	products,
	showPrice = true,
}) => {
	let start;
	let processedProducts;

	if  (perPage) {
		start = (page - 1) * perPage;
		processedProducts = products.slice(start, start + perPage);
	} else {
		processedProducts = products;
	}

	return (
		<ul className="product-list">
			{processedProducts.map(({ node }, idx) => {
				let productPath = '';

				if (node.data.Special_Product_Page) {
					productPath = `/shop/${node.data.Special_Page_Path}`;
				} else {
					productPath = `/product/${node.data.Reference}`;
				}

				return (
					<li key={`${node.data.Reference}-${idx}`}>
						<Link to={productPath}>
							<div className="product-cell__image-frame-wrapper">
								<div className="product-cell__image-frame">
									{(node.data.Image_File_Path) ? (
										<CDNImage
											imagePath={node.data.Image_File_Path}
											alt={node.data.Name}
											height={792}
											width={792}
										/>
									) : null}
								</div>
							</div>
							<div className="product-cell__label">
								<span
									className="name"
									dangerouslySetInnerHTML={{ __html: marked(node.data.Name).replace('<p>', '').replace('</p>', '') }}
								/>
								{(node.data.Artist) ? (
									<span className="artist">
										{node.data.Artist}
										{(node.data.Year) ? (
											<>, {node.data.Year}</>
										) : null}
									</span>
								) : null}
								{showPrice && (
									<span className="prices">
										From <StartingPrintPrice priceProfile={node.data.Price_Profile_Name[0]} />{' / '}
										Size: {node.data.Sizes.join(' ')}
									</span>
								)}
								{node.data.Unavailable && (
									<span className="unavailable-tag">Currently Unavailable</span>
								)}
							</div>
						</Link>
					</li>
				);
			})}
		</ul>
	)
};

export default ProductList;
